import { NgModule } from '@angular/core';

import { ContactDisplayPipe } from './contact-display.pipe';
import { DownloadPrivatePipe } from './download-private.pipe';
import { DownloadPublicPipe } from './download.pipe';
import { GoogleMapsUrlPipe } from './google-maps-url.pipe';
import { NationalPhoneNumberPipe } from './national-phone-number.pipe';
import { Nl2brPipe } from './nl2br.pipe';
import { SearchPipe } from './search.pipe';
import { LinkVariablePipe } from './link-variable.pipe';

@NgModule({
  declarations: [
    ContactDisplayPipe,
    DownloadPublicPipe,
    DownloadPrivatePipe,
    GoogleMapsUrlPipe,
    LinkVariablePipe,
    NationalPhoneNumberPipe,
    Nl2brPipe,
    SearchPipe
  ],
  providers: [DownloadPublicPipe],
  exports: [
    ContactDisplayPipe,
    DownloadPublicPipe,
    DownloadPrivatePipe,
    GoogleMapsUrlPipe,
    LinkVariablePipe,
    NationalPhoneNumberPipe,
    Nl2brPipe,
    SearchPipe
  ]
})
export class PipesModule {}
